import { RENT_NAVIGATOR_BASE_PATH } from '../../routes/dashboardPaths';
import { features } from '../dashboards/dashboardFramework/helpers/features';

export const SIGN_UP_FEATURE_PARAM_VALUES = {
  'rent-navigator': features.REAMS,
  'retail-market-analysis': features.RETAIL_MARKET_ANALYSIS,
};

export const DEFAULT_TRIAL_PERIOD_DAYS = 14;

export const SIGN_UP_FEATURE_URLS = {
  // Redirect feature returned by the magic-link API
  rentNavigator: 'rentNavigator',
  // Sign-up URL segment
  rentNavigatorPath: 'rent-navigator',
};

export const SIGN_UP_PATH = `/signup/${SIGN_UP_FEATURE_URLS.rentNavigatorPath}`;

// Old sign-up URL, redirected to SIGN_UP_PATH
export const LEGACY_SIGN_UP_PATH = `/signup/${features.REAMS}`;

export const DASHBOARD_PATHS = {
  reams: RENT_NAVIGATOR_BASE_PATH,
  ai: '/chaos-ai',
  login: '/login',
};

export type FeatureTypeKey = keyof typeof SIGN_UP_FEATURE_PARAM_VALUES;

export const getRedirectPathFromFeatureType = (featureType?: string) => {
  switch (featureType) {
    case SIGN_UP_FEATURE_URLS.rentNavigator:
    case SIGN_UP_FEATURE_URLS.rentNavigatorPath:
      return DASHBOARD_PATHS.reams;
    default:
      return DASHBOARD_PATHS.login;
  }
};

export const SIGNUP_TYPE_KEYS = {
  default: 'default',
  sso: 'sso',
};

export const SIGN_UP_PASSWORD_PATTERN =
  '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,}$';

export const SSO_SIGNUP_PROVIDERS = {
  microsoft: 'microsoft',
  google: 'google',
};
